const SearchCaExpensesForm = ({ toggleFilters }) => {
  return (
    <>
      {toggleFilters && (
        <div className="rounded bg-gray mb-3 p-3">
          <div className="row">
            <div className="col-lg-3 form-group">
              <label for="orderby" className="form-label fw-bolder">
                Order By
              </label>
              <select
                name="orderby"
                id="orderby"
                className="submit_on_change form-control form-control"
              >
                <option value="ID">ID</option>
                <option value="amount">Amount</option>
                <option value="paid_date">Date</option>
                <option value="payment_description">Description</option>
                <option value="updated_at">Update Time</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="order" className="form-label fw-bolder">
                Order
              </label>
              <select name="order" id="order" className="form-control">
                <option value="ascending">Ascending</option>
                <option value="descending">Descending</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="start_date" className="form-label fw-bolder">
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                name="start_date"
                id="start_date"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="end_date" className="form-label fw-bolder">
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                name="end_date"
                id="end_date"
                value=""
              />
            </div>
            <div className="clearboth"></div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <button type="submit" className="btn site_btn text-white">
                Search
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchCaExpensesForm;
